import { Link } from 'react-router-dom';
import WorkCard from '@/components/feature/WorkCard';
import { works } from '@/mocks/works';

export default function FeaturedWorks() {
  const featured = works.slice(0, 4);

  return (
    <section className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <span className="text-xs tracking-[0.25em] text-accent-600">EDITOR'S PICK</span>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mt-3">编辑精选作品</h2>
            <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-2xl">
              甄选小仓优子代表性的影视作品，从都市剧情到刑侦悬疑，见证她表演上的不断突破。
            </p>
          </div>
          <Link
            to="/category/works"
            className="inline-flex items-center gap-1 text-sm text-accent-600 hover:text-accent-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部作品
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {featured.map((work) => (
            <WorkCard key={work.id} work={work} />
          ))}
        </div>
      </div>
    </section>
  );
}